import { ActionCardModel, QuestionNode, WidgetNode } from '@playbooks/action-cards-utils'
import { Question } from '@playbooks/core/src/interfaces/ActionCard'

/**
 * Retrieves all elements from the action card model that have associated code.
 * @param actionCardsModel The action card model to search.
 * @returns An array of elements with code.
 */
export default function getElementsWithCode(actionCardsModel: ActionCardModel) {
  return actionCardsModel
    .getSearchService()
    .filter(node => {
      if (hasCode(node)) {
        return !!node.getCode()
      }

      return false
    })
    .map(node => node.data) as Question[]
}

function hasCode(node: object): node is QuestionNode | WidgetNode {
  return typeof (node as QuestionNode | WidgetNode).getCode === 'function'
}
